/* eslint-disable */
import { useState, useCallback, useEffect, useRef } from 'react';
import type { FC } from 'react';
import { Box, Container, Grid, Typography } from '@material-ui/core';
import { useTranslation } from 'react-i18next';
import useIndicators from 'src/hooks/useIndicators';
import useAuth from 'src/hooks/useAuth';
import useIsMountedRef from '../../hooks/useIsMountedRef';
import DatePicker from "react-datepicker";
import { useStyles } from 'src/components/dashboard/style';
import 'react-datepicker/dist/react-datepicker.css'
import WidgetTile from 'src/components/dashboard/overview/masterOverview/ComponentesPrior/WidgetTile';
import TrendingUpIcon from '@material-ui/icons/TrendingUp';
import TrendingDownIcon from '@material-ui/icons/TrendingDown';
import MonetizationOnIcon from '@material-ui/icons/MonetizationOn';
import WidgetBalance from 'src/components/dashboard/overview/masterOverview/ComponentesPrior/WidgetBalance';
import TablaFinanciera from 'src/components/dashboard/overview/masterOverview/Tablas/TablaFinanciera';
import WidgeTwoColumns from 'src/components/dashboard/overview/masterOverview/ComponentesPrior/WidgeTwoColumns';
import ChartUtilidadNeta from 'src/components/dashboard/overview/masterOverview/Charts/ChartUtilidadNeta';
import ChartDeficit from 'src/components/dashboard/overview/masterOverview/Charts/ChartDeficit';
import ChartCambiosCapitalTrabajo from 'src/components/dashboard/overview/masterOverview/Charts/ChartCambiosCapitalTrabajo';

const OverviewDetalleIndicadoresFinancieros: FC = () => {
  const classes = useStyles();
  const { getDashboardMaster, dashboardMaster, getTradeByBusiness } =
    useIndicators();
  const isMountedRef = useIsMountedRef();
  const { user } = useAuth();
  const [info, setInfo] = useState<any>();
  const [valueUtilidadNeta, setValueUtilidadNeta] = useState([]);
  const { t } = useTranslation('dashboard');
  const date = new Date();
  const utc = date.getTime() + date.getTimezoneOffset() * 60000;
  const nd = new Date(utc + 3600000 * -5);
  const now = `${nd.getFullYear()}-${nd.getMonth() + 1}-${nd.getDate()}`;
  const topRef = useRef(null);
  const bottomRef = useRef(null);
  const [goingUp, setGoingUp] = useState(false);
  const [btnUp, setBtnUp] = useState(false);
  const prevScrollY = useRef(
    topRef.current !== null &&
      topRef.current.getBoundingClientRect() !== undefined
      ? topRef.current.getBoundingClientRect().y
      : 0
  );

  const [valueDate, setvalueDate] = useState(new Date());
  const [openTable, setOpenTable] = useState(false);

  const executeScroll = () => {
    if (goingUp) {
      if (topRef.current === null) return;
      topRef.current.scrollIntoView();
      setGoingUp(false);
    } else if (!goingUp) {
      if (bottomRef.current === null) return;
      bottomRef.current.scrollIntoView();
      setGoingUp(true);
    }
  };

  const handleScroll = () => {
    if (topRef.current === null) return;
    const currentScrollY = topRef.current.getBoundingClientRect().y;
    if (prevScrollY.current < currentScrollY && goingUp) {
      setGoingUp(false);
    }
    if (prevScrollY.current > currentScrollY && !goingUp) {
      setGoingUp(true);
    }
    prevScrollY.current = currentScrollY;
  };

  const EtlStatus = async () => {
    try {
      if (user['rolDesc'] === 'master' || user['rolDesc'] === 'estandar') {
        const obj = {
          businessId: user.businessId.business_id,
          date: now,
        };
        await getDashboardMaster();
      }
    } catch (error) {
      console.error(error);
    }
  };

  useEffect(() => {
    EtlStatus();
  }, []);

  useEffect(() => {
    setInfo(dashboardMaster);
  }, [dashboardMaster]);

  useEffect(() => {
    window.addEventListener('wheel', handleScroll);

    return () => window.removeEventListener('wheel', handleScroll);
  }, [goingUp]);

  const onIdle = () => {
    window.location.reload();
  };

  const handleOnDateChange = (date: any) => {
    setvalueDate(date);
  }

  const handleOpenTable = (newValue) => {
    setOpenTable(newValue);
  };

  const dataTablaGastosPorDia = {
    header: [
      "Gastos del día",
      "lunes",
      "martes",
      "miércoles",
      "jueves",
      "viernes",
      "sábado",
      "domingo"
    ],
    rows: [
      ["Operaciones", 1, 2, 3, 4, 5, 6, 7],
      ["Ventas", 1, 2, 3, 4, 5, 6, 7],
      ["Administrativo", 1, 2, 3, 4, 5, 6, 7],
      ["Financieros", 1, 2, 3, 4, 5, 6, 7],
      ["No Operaciones", 1, 2, 3, 4, 5, 6, 7],
      ["Impuestos", 1, 2, 3, 4, 5, 6, 7],
    ],
  };

  const dataTablaActualDelMes = {
    header: [
      "",
      "Actual del Mes",
    ],
    rows: [
      ["Ventas del Mes", 98627.35],
      ["COGS y Gastos del Mes", 43602.98],
      ["Utilidad Neta", 15292.11]
    ],
  };

  const info2Columnas = [
    { name: 'Costos de Venta y Producción', value: 43734.67 },
    { name: 'Utilidad Bruta', value: 55321.29 },
    { name: 'Utilidad Neta', value: 15321.29 },
  ];

  const gastos = [
    { name: 'Gasto de Ventas', value: 1146734.67 },
    { name: 'Gasto Administrativos', value: 238321.29 },
    { name: 'Gasto Financieros', value: 238321.29 },
    { name: 'Gastos No Operacionales', value: 238321.29 },
    { name: 'Total Gastos', value: 1385055.96 },
  ];

  const activosCorrientesDeHoy = {
    title: 'Utilidad Neta (Comportamiento Acumulativo)',
    series: [10, 30, 60],
    labels: ['Inventario', 'Bancos', 'Cuentas por Cobrar'],
  };

  const dataTablaFinanciera =
  {
    header: [
      '01/05/2022',
      '02/05/2022',
      '03/05/2022',
      '04/05/2022',
      '05/05/2022',
      '06/05/2022',
      '07/05/2022',
    ],
    rows: [
      {
        data: ["1. Activos", 1, 2, 3, 4, 5, 6, 7],
        subRows: [
          { data: ["1.1 Activo Corriente", 1, 2, 3, 4, 5, 6, 7] },
          { data: ["1.1.1 Efectivo y Equivalentes de Efectivo", 1, 2, 3, 4, 5, 6, 7] },
          { data: ["1.1.2 Inventario", 1, 2, 3, 4, 5, 6, 7] },
          { data: ["1.1.3 Servicios y otros Pagos Anticipados", 1, 2, 3, 4, 5, 6, 7] },
          { data: ["1.1.4 Impuestos Corrientes", 1, 2, 3, 4, 5, 6, 7] },
          { data: ["1.1.5 Otros Activos Corrientes", 1, 2, 3, 4, 5, 6, 7] },
          { data: ["Totales Activo Corriente", 1, 2, 3, 4, 5, 6, 7], bold: true },
          { data: ["Totales Activo", 1, 2, 3, 4, 5, 6, 7], bold: true },
        ],
      },
      {
        data: ["2. Pasivos", 1, 2, 3, 4, 5, 6, 7],
        subRows: [
          { data: ["2.1 Pasivo Corriente", 1, 2, 3, 4, 5, 6, 7] },
          { data: ["2.1.1 Obligaciones Financieras", 1, 2, 3, 4, 5, 6, 7] },
          { data: ["2.1.2 Cuentas por Pagar", 1, 2, 3, 4, 5, 6, 7] },
          { data: ["2.1.3 Impuestos Corrientes", 1, 2, 3, 4, 5, 6, 7] },
          { data: ["2.1.4 Otros Pasivos Corrientes", 1, 2, 3, 4, 5, 6, 7] },
          { data: ["Totales Pasivo Corriente", 1, 2, 3, 4, 5, 6, 7], bold: true },
          { data: ["Totales Pasivos", 1, 2, 3, 4, 5, 6, 7], bold: true },
        ],
      },
      {
        data: ["3. Patrimonio", 1, 2, 3, 4, 5, 6, 7],
        subRows: [
          { data: ["3.1 Pasivo Corriente", 1, 2, 3, 4, 5, 6, 7] },
          { data: ["3.1.1 Obligaciones Financieras", 1, 2, 3, 4, 5, 6, 7] },
          { data: ["3.1.2 Cuentas por Pagar", 1, 2, 3, 4, 5, 6, 7] },
          { data: ["3.1.3 Impuestos Corrientes", 1, 2, 3, 4, 5, 6, 7] },
          { data: ["3.1.4 Otros Pasivos Corrientes", 1, 2, 3, 4, 5, 6, 7] },
          { data: ["Totales Patrimonio", 1, 2, 3, 4, 5, 6, 7], bold: true },
        ],
      },
    ],
  };

  return (
    <div>
      <Box
        sx={{
          backgroundColor: 'background.default',
          minHeight: '100%',
          paddingTop: 2,
          paddingBottom: 8,
        }}
      >
        <Container maxWidth={false}>

          <Grid container justifyContent="space-between" spacing={3}>
            <Grid item xs={12} md={10} sx={{ paddingTop: '7px' }}>
              <Typography
                sx={{
                  paddingLeft: 1,
                  fontWeight: 700,
                  fontSize: '1.825rem',
                }}
                color="textSecondary"
              >
                Detalle de Indicadores Financieros Proforma
              </Typography>
            </Grid>
            <Grid item xs={12} md={2}>
              <Typography
                color="#42526E"
                fontWeight={500}
                ml={1}
                width="50%"
                display="flex">Fecha</Typography>
              <DatePicker
                selected={valueDate}
                onChange={handleOnDateChange}
                dateFormat="yyyy-MM-dd"
                className={classes.datePicker}
              />

            </Grid>
            
            <Grid item xs={12}>
              <div ref={bottomRef}>
                {/*<TablaFinanciera data={dataTablaFinanciera} openTable={handleOpenTable}/>*/}
              </div>
            </Grid>
          </Grid>
        </Container>
      </Box>
    </div>
  );
};

export default OverviewDetalleIndicadoresFinancieros;


